import { EMessageV2Status } from '@cian/chats-api';

import { CHATBOT_ID } from '../constants/chatbotId';
import { EStatus } from '../repositories/cian-chat-bot/entities/message/MessageSchema';
import { IChatbotMessageSchema } from '../types/chatbot';
import { TMessageSchema } from '../types/messages';

const MESSAGE_STATUS = {
  [EStatus.Deleted]: EMessageV2Status.Deleted,
  [EStatus.DeliveredToServer]: EMessageV2Status.DeliveredToServer,
};

function mapStatusMessage(status: EStatus): EMessageV2Status {
  const newStatus = MESSAGE_STATUS[status];
  if (newStatus) {
    return newStatus as EMessageV2Status;
  } else {
    return EMessageV2Status.DeliveredToServer;
  }
}

export const mapChatbotMessageToChatMessage = (
  message: IChatbotMessageSchema,
  index?: number,
  unreadMessagesCount?: number,
): TMessageSchema => {
  const { offers, created, status, rowVersion } = message;

  return {
    ...message,
    chatId: CHATBOT_ID,
    offers:
      offers?.map(offer => ({
        ...offer,
        url: `/sale/flat/${offer.realtyOfferId}/`,
      })) || [],
    userId: 0,
    created,
    status: mapStatusMessage(status),
    rowVersion,
    unread: index !== undefined && !!unreadMessagesCount && index < unreadMessagesCount,
  };
};
